import { Address } from './Address';

export class Partner {
    public id!: string;
    public code!: string;
    public name!: string;
    public description?: string;
    public company?: string;
    public ean?: string;
    public reference?: string;
    public address?: Address;
    public email?: string;
    public telephone?: string;
}